<template>
  <div>
    <v-btn
      @click="dialog = true"
      color="primary"
      class="ml-2"
    >
      Novo
    </v-btn>

    <SysDialog
      v-model="dialog"
      titulo="Novo menu de parametrização"
      @click:primary="salvarMenu()"
    >
      <Form
        :item="item"
        :dialog="dialog"
      />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import Form from './Includes/_form.vue';
import { salvarMenusConfiguracaoMenuParametrizacao } from '../../Api';

export default {
  components: { SysDialog, Form },
  data: () => ({
    dialog: false,
    item: {
      id_modulo: '',
      descricao: '',
      url: '',
      icone: '',
      ordem: ''
    }
  }),
  methods: {
    fecharDialog() {
      this.dialog = false;
      this.item.descricao = '';
      this.url = '',
      this.icone = '',
      this.ordem = ''
    },
    salvarMenu() {
      this.$store.dispatch(
        'loading/addRequisicao',
        salvarMenusConfiguracaoMenuParametrizacao(this.item)
          .then(() => this.$emit('atualizar-tela-inicial-menu-configuracao-menu'))
          .catch(() => this.Helpers.logout())
          .finally(() => this.fecharDialog())
        );
    },
  }
}
</script>

<style>

</style>
